/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { configurationPath } from '../settings';
import epoAxios from '../shared/http/epoAxios';
import { getAccessToken } from '../redux/features/auth/auth.service';

const getHeaders = () => {
  const token = getAccessToken();
  if (token) {
    return {
      'Cache-Control': 'no-cache',
      Authorization: `Bearer ${token}`,
    };
  }
  return { 'Cache-Control': 'no-cache' };
};

const getConfigData = async (url) => {
  const { data } = await epoAxios.get(url, { method: 'GET', headers: getHeaders() });
  return data;
};

export default {
  getResource: (url) => {
    return getConfigData(url);
  },
  getDefaultVersion: () => {
    return getConfigData(`${configurationPath}/configuration/versions/default`);
  },
};
